import { ref } from 'vue'
import planUsageService from '@/services/planUsage.service'

const subscriptionUrl = ref('')
const usageUrl = ref('')
let loadPromise: Promise<void> | null = null

async function ensurePortalUrls(): Promise<void> {
  if (subscriptionUrl.value) return
  if (loadPromise) {
    await loadPromise
    return
  }
  loadPromise = (async () => {
    try {
      const snapshot = await planUsageService.getPlanUsage()
      subscriptionUrl.value = snapshot.portal_subscription_url || ''
      usageUrl.value = snapshot.portal_usage_url || ''
    } catch {
      subscriptionUrl.value = ''
      usageUrl.value = ''
    } finally {
      loadPromise = null
    }
  })()
  await loadPromise
}

/**
 * Cached customer-portal URLs from plan usage API.
 */
export function usePortalSubscriptionUrl() {
  return {
    subscriptionUrl,
    usageUrl,
    ensurePortalUrls,
  }
}
